import { PromotionBalanceEntry } from '@gongxigames/framework/promotions';

export interface IPromotionalStatusesInterface {
    isQueued(balance: PromotionBalanceEntry): boolean;
    isInUse(balance: PromotionBalanceEntry): boolean;
    isCompleted(balance: PromotionBalanceEntry): boolean;
    isExpired(balance: PromotionBalanceEntry): boolean;
    isOptOut(balance: PromotionBalanceEntry): boolean;
    isDisabled(balance: PromotionBalanceEntry): boolean;
}
